// ReturnPolicy.jsx
import React from "react";

const ReturnPolicy = () => {
  return (
    <div className="return-policy-wrapper">
      <style>
        {`
          /* ===== RESET & BASE ===== */
          .return-policy-wrapper {
            background: #f9f7f4;
            min-height: 100vh;
            display: flex;
            justify-content: center;
            align-items: flex-start;
            padding: 1.2rem 0.8rem 2rem;
            font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
            box-sizing: border-box;
          }

          .return-policy-wrapper *,
          .return-policy-wrapper *::before,
          .return-policy-wrapper *::after {
            box-sizing: border-box;
            margin: 0;
            padding: 0;
          }

          .return-policy-container {
            max-width: 1200px;
            width: 100%;
            background: white;
            border-radius: 28px;
            box-shadow: 0 8px 32px rgba(0, 0, 0, 0.06), 0 2px 8px rgba(0, 0, 0, 0.02);
            padding: 1.8rem 1.8rem 2rem;
            transition: padding 0.2s ease;
          }

          /* ===== HEADER ===== */
          .policy-header {
            margin-bottom: 2rem;
            border-bottom: 2px solid #f0ebe4;
            padding-bottom: 1.2rem;
          }

          .policy-header h1 {
            font-size: 2rem;
            font-weight: 700;
            letter-spacing: -0.02em;
            color: #1e1e1e;
            display: flex;
            align-items: center;
            gap: 0.3rem;
          }

          .policy-header h1 i {
            font-size: 1.8rem;
            color: #d4a373;
          }

          .effective-date {
            font-size: 0.85rem;
            font-weight: 500;
            color: #5e5e5e;
            background: #f0ebe4;
            display: inline-block;
            padding: 0.2rem 0.9rem;
            border-radius: 40px;
            margin-top: 0.4rem;
          }

          .intro-text {
            margin-top: 0.8rem;
            font-size: 1rem;
            color: #2d2d2d;
            line-height: 1.6;
            background: #fcf9f6;
            padding: 0.8rem 1.2rem;
            border-radius: 14px;
            border-left: 4px solid #d4a373;
            font-weight: 500;
          }

          /* ===== POLICY SECTIONS ===== */
          .policy-sections {
            display: flex;
            flex-direction: column;
            gap: 1.4rem;
          }

          .policy-card {
            background: #ffffff;
            border-radius: 20px;
            padding: 1.2rem 1.5rem;
            border: 1px solid #f0ebe4;
            transition: border-color 0.2s;
          }

          .policy-card:hover {
            border-color: #e2d6c8;
          }

          /* Main card (highlight) */
          .main-card {
            background: #fcf9f6;
            border-left: 6px solid #bc6c25;
            border-radius: 16px;
          }

          .highlight-text {
            font-size: 1.05rem;
            color: #1e1e1e;
            line-height: 1.6;
            margin: 0;
            display: flex;
            align-items: flex-start;
            gap: 0.3rem;
          }

          .highlight-text i {
            font-size: 1.2rem;
            margin-top: 0.1rem;
          }

          .highlight-text strong {
            font-weight: 700;
            color: #bc6c25;
          }

          /* ===== Headings ===== */
          .policy-card h2 {
            font-size: 1.2rem;
            font-weight: 600;
            color: #1e1e1e;
            margin-bottom: 1rem;
            display: flex;
            align-items: center;
            gap: 0.4rem;
            border-bottom: 2px solid #f0ebe4;
            padding-bottom: 0.5rem;
          }

          .policy-card h2 i {
            font-size: 1.2rem;
            width: 1.6rem;
            text-align: center;
          }

          /* ===== Issues List ===== */
          .issues-list {
            list-style: none;
            padding: 0;
            margin: 0;
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 0.5rem 1rem;
          }

          .issues-list li {
            display: flex;
            align-items: center;
            gap: 0.6rem;
            font-size: 0.95rem;
            color: #1e1e1e;
            padding: 0.4rem 0.6rem;
            background: #faf8f6;
            border-radius: 40px;
            border: 1px solid #f0ebe4;
          }

          .issues-list li i {
            font-size: 0.95rem;
            width: 1.4rem;
            text-align: center;
            color: #bc6c25;
          }

          /* ===== Action Card ===== */
          .action-card {
            background: #fcf9f6;
            border: 1px solid #e2d6c8;
          }

          .action-text {
            font-size: 0.98rem;
            color: #1e1e1e;
            line-height: 1.7;
            margin-bottom: 0.8rem;
          }

          .action-text strong {
            color: #bc6c25;
            font-weight: 600;
          }

          .action-badge {
            display: inline-flex;
            align-items: center;
            gap: 0.4rem;
            background: #e8e0d8;
            padding: 0.3rem 1rem;
            border-radius: 40px;
            font-size: 0.85rem;
            font-weight: 500;
            color: #1e1e1e;
            margin-top: 0.2rem;
          }

          .action-badge i {
            color: #bc6c25;
          }

          /* ===== Contact Card ===== */
          .contact-card {
            background: #fcf9f6;
            border: 1px solid #e2d6c8;
          }

          .contact-details {
            display: flex;
            flex-direction: column;
            gap: 0.7rem;
            margin-top: 0.6rem;
          }

          .contact-item {
            display: flex;
            align-items: center;
            gap: 0.8rem;
            font-size: 0.98rem;
            padding: 0.5rem 1rem;
            background: white;
            border-radius: 60px;
            border: 1px solid #ede7df;
            transition: background 0.2s, border-color 0.2s;
          }

          .contact-item i {
            width: 1.6rem;
            font-size: 1.1rem;
            color: #bc6c25;
            text-align: center;
          }

          .contact-item a {
            text-decoration: none;
            color: #1e1e1e;
            font-weight: 500;
            word-break: break-word;
            flex: 1;
          }

          .contact-item a:hover {
            color: #bc6c25;
            text-decoration: underline;
          }

          /* ===== FOOTER ===== */
          .policy-footer {
            margin-top: 2.2rem;
            text-align: center;
            font-size: 0.85rem;
            color: #5e5e5e;
            border-top: 1px solid #f0ebe4;
            padding-top: 1.2rem;
          }

          /* ===== HOVER EFFECTS ===== */
          .contact-item:hover {
            background: #f7f2ec;
            border-color: #d4a373;
          }

          .issues-list li:hover {
            background: #f5efe8;
            border-color: #d4a373;
            transition: 0.15s;
          }

          /* ===== RESPONSIVE (mobile-first) ===== */
          @media (max-width: 700px) {
            .return-policy-wrapper {
              padding: 0.6rem 0.4rem 1.2rem;
            }

            .return-policy-container {
              padding: 1rem 0.8rem 1.5rem;
              border-radius: 20px;
            }

            .policy-header h1 {
              font-size: 1.6rem;
            }

            .policy-header h1 i {
              font-size: 1.4rem;
            }

            .intro-text {
              font-size: 0.92rem;
              padding: 0.6rem 0.9rem;
            }

            .policy-card {
              padding: 0.9rem 1rem;
              border-radius: 16px;
            }

            .policy-card h2 {
              font-size: 1.05rem;
              margin-bottom: 0.7rem;
            }

            .highlight-text {
              font-size: 0.95rem;
            }

            .issues-list {
              grid-template-columns: 1fr;
              gap: 0.4rem;
            }

            .issues-list li {
              font-size: 0.88rem;
              padding: 0.3rem 0.6rem;
            }

            .action-text {
              font-size: 0.92rem;
            }

            .action-badge {
              font-size: 0.8rem;
              padding: 0.2rem 0.8rem;
            }

            .contact-item {
              font-size: 0.9rem;
              padding: 0.4rem 0.8rem;
              gap: 0.6rem;
            }

            .contact-item i {
              width: 1.4rem;
              font-size: 1rem;
            }

            .effective-date {
              font-size: 0.75rem;
            }

            .policy-footer {
              font-size: 0.78rem;
              margin-top: 1.8rem;
              padding-top: 1rem;
            }
          }

          @media (max-width: 480px) {
            .return-policy-container {
              padding: 0.8rem 0.6rem 1.2rem;
              border-radius: 16px;
            }

            .policy-header h1 {
              font-size: 1.3rem;
            }

            .policy-header h1 i {
              font-size: 1.2rem;
            }

            .policy-card {
              padding: 0.7rem 0.8rem;
              border-radius: 14px;
            }

            .policy-card h2 {
              font-size: 0.95rem;
              padding-bottom: 0.3rem;
            }

            .highlight-text {
              font-size: 0.88rem;
            }

            .issues-list li {
              font-size: 0.82rem;
              padding: 0.25rem 0.5rem;
            }

            .issues-list li i {
              font-size: 0.8rem;
              width: 1.2rem;
            }

            .action-text {
              font-size: 0.85rem;
            }

            .contact-item {
              font-size: 0.82rem;
              padding: 0.35rem 0.6rem;
              gap: 0.4rem;
              border-radius: 40px;
            }

            .contact-item i {
              width: 1.2rem;
              font-size: 0.9rem;
            }

            .intro-text {
              font-size: 0.85rem;
              padding: 0.5rem 0.7rem;
            }

            .effective-date {
              font-size: 0.7rem;
              padding: 0.15rem 0.7rem;
            }

            .action-badge {
              font-size: 0.75rem;
              padding: 0.15rem 0.7rem;
            }

            .policy-footer {
              font-size: 0.72rem;
              margin-top: 1.5rem;
              padding-top: 0.8rem;
            }
          }
        `}
      </style>

      <div className="return-policy-container">
        {/* Header */}
        <div className="policy-header">
          <h1>
            <i className="fas fa-rotate-left"></i>
            Return Policy
          </h1>
          <p className="effective-date">Effective Date: 30 March 2026</p>
          <p className="intro-text">
            At Maamaa's, we prioritize food quality and customer safety.
          </p>
        </div>

        {/* Policy Sections */}
        <div className="policy-sections">
          {/* Main Policy */}
          <section className="policy-card main-card">
            <p className="highlight-text">
              <i className="fas fa-exclamation-triangle"></i>
              Due to the perishable nature of food items and hygiene standards,
              <strong> food products cannot be returned</strong> once they have been delivered.
            </p>
          </section>

          {/* Issues Section */}
          <section className="policy-card">
            <h2>
              <i className="fas fa-list-check"></i>
              If you experience any of the following issues:
            </h2>
            <ul className="issues-list">
              <li>
                <i className="fas fa-box-open"></i>
                Incorrect order delivered
              </li>
              <li>
                <i className="fas fa-cube"></i>
                Missing items
              </li>
              <li>
                <i className="fas fa-bottle-water"></i>
                Damaged or spilled food
              </li>
              <li>
                <i className="fas fa-truck-fast"></i>
                Order not delivered
              </li>
            </ul>
          </section>

          {/* Action Section */}
          <section className="policy-card action-card">
            <h2>
              <i className="fas fa-bullhorn"></i>
              What to do
            </h2>
            <p className="action-text">
              Please contact our customer support immediately. After verification, we may provide a
              <strong> replacement</strong> or process a <strong>refund</strong> in accordance with our Refund Policy.
            </p>
            <div className="action-badge">
              <i className="fas fa-clock"></i>
              Support available 24/7
            </div>
          </section>

          {/* Contact Section */}
          <section className="policy-card contact-card">
            <h2>
              <i className="fas fa-headset"></i>
              For assistance, contact:
            </h2>
            <div className="contact-details">
              <div className="contact-item">
                <i className="fas fa-envelope"></i>
                <a href="mailto:support@maamaas.com">info@maamaas.com</a>
              </div>
              <div className="contact-item">
                <i className="fas fa-globe"></i>
                <a href="https://www.maamaas.com" target="_blank" rel="noopener noreferrer">
                  https://www.maamaas.com
                </a>
              </div>
            </div>
          </section>
        </div>

        {/* Footer */}
        <div className="policy-footer">
          <p>
            <i className="fas fa-heart" style={{ color: "#bc6c25", marginRight: "0.3rem" }}></i>
            Maamaa's – quality first, always
          </p>
        </div>
      </div>
    </div>
  );
};

export default ReturnPolicy;